/* @flow */
import React from 'react';

import Item from './Item';
import { Tooltip } from 'components/UIKit/Tooltip';
import Row from 'components/UIKit/Flex/Row';

let baseStyle = {
  alignItems: 'center',
  color: '#888',
  fontSize: '1.25rem',
  padding: '0.75rem',
  cursor: 'pointer'
};

export default function NavItem({
  tooltip,
  spyId,
  active,
  children,
  style,
  handleOnClick
}: any): React.Element {
  return (
      <Item
        style={{
          ...baseStyle,
          ...style,
          ...((spyId && spyId === active) && {
            backgroundColor: '#ccc',
            color: 'white',
            cursor: 'default'
          })
        }}
        onClick={handleOnClick}
      >
        {tooltip &&
          <Tooltip Component={<Row>{tooltip.text}</Row>}>
            <span>{ children }</span>
          </Tooltip>
        }
        {!tooltip && children}
    </Item>
  );
}
